/* Uberflip GWL OB-9563 start here */
const { createElem } = require('../helperFunctions');
const getTiles = require('./getTiles');
class Sidebar {

    constructor(filterData) {
        this.filterData = filterData;
    }

    getFilterItemHtml(filterTitle, filterOpt) {

        const checkboxValue = filterOpt.tag;
        const checkboxLabel = filterOpt.label;

        const item = createElem('li', { class: 'boxclass' });
        const input = createElem('input', { type: 'checkbox', id: checkboxLabel, name: filterTitle, value: checkboxValue });
        const label = createElem('label', { for: checkboxLabel }, checkboxLabel);

        item.appendChild(input);
        item.appendChild(label);

        return item;
    }

    getCategoryHtml(filterTitle, filterOptions) {
        const fieldset = createElem('fieldset', { id: `onBrand__filter--${filterTitle}` });
        // const legend = createElem('legend', { class: 'onbrand__filter--title' }, filterTitle);

        const filterList = createElem('ul', { class: 'onBrand__filter--dropdown', role: 'menu', 'aria-label': filterTitle });

        // fieldset.appendChild(legend);
        fieldset.appendChild(filterList);


        for (let i = 0; i < filterOptions.length; i++) {
            const filterItem = this.getFilterItemHtml(filterTitle, filterOptions[i]);
            filterList.appendChild(filterItem);
        }

        return fieldset;
    }


    getFormHtml() {
        const divelem = createElem('div', { class: 'filter-box' });
        const form = createElem('form', { id: 'onBrand__filter--form' });
        for (const filter in this.filterData) {
            const filterCategory = this.getCategoryHtml(filter, this.filterData[filter]);
            form.appendChild(filterCategory);
        }
        divelem.appendChild(form);
        const filterTitle = `
            <div class="filter-heading-clear">
            <i class="fas fa-times"></i>
            <span class="avenir-regular link-blue filter-heading-clear-link" data-attribute="">Reset filters</span>
        </div>`;

        form.insertAdjacentHTML('beforeend', filterTitle);

        return divelem;
    }



    attatchEvents(handleCheckboxChange) {
        const checkboxInputs = [...document.querySelectorAll('#onBrand__filter--form input[type=checkbox]')];

        // Define the event listener function
        function handleChange(event) {
            const clickedCheckbox = event.target;

            // Uncheck all other checkboxes except the clicked one
            checkboxInputs.forEach((checkbox) => {
                if (checkbox !== clickedCheckbox) {
                    checkbox.checked = false;
                }
            });

            // Pass the value of the clicked checkbox to the callback function
            handleCheckboxChange(clickedCheckbox.value);
        }

        // Attach the event listener to all checkboxes
        checkboxInputs.forEach((checkbox) => {
            checkbox.addEventListener('change', handleChange);
        });

        return this;
    }




    init() {
        const target = document.querySelector('#collection-items ul');
        if (!target) {
            throw new ReferenceError('Could not attach sidebar!');
        }
        document.querySelector('body').classList.add('onBrand__filter');
        target.insertBefore(this.getFormHtml(), target.firstChild);
        const featuredTile = document.querySelector('ul.featuredTile');
        if (featuredTile) {
            target.insertBefore(featuredTile, target.firstChild.nextSibling);
        }
        getTiles();

        return this;

    }

}

module.exports = Sidebar;
/* Uberflip GWL OB-9563 end here */


// WEBPACK FOOTER //
// ./script-partials/filter/Sidebar.js